import { UI_PRIMITIVE__context_menu_item } from '@/components/ui/context_menu/UI_PRIMITIVE__context_menu_item';
import { SVGComponent } from '@/types/types';

interface PROPS {
  Icon: SVGComponent;
  text: string;
  on_click: () => Promise<void>;
  disabled?: boolean;
}

export function CONTEXT_MENU_ITEM__field_base({ Icon, text, on_click, disabled = false }: PROPS) {
  /*
   * HTML
   */
  return (
    <UI_PRIMITIVE__context_menu_item onClick={on_click} {...{ disabled }}>
      <div className="flex flex-row items-center justify-start size-full gap-1 ">
        <Icon className="size-3" />
        <span className="truncate text-xs">{text}</span>
      </div>
    </UI_PRIMITIVE__context_menu_item>
  );
}
